module.exports = __webpack_public_path__ + "static/media/SR502-P8SD Copy.74575437.png";